;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { VideoClass } from '@/lib/types/api/video';
import { isDateInPast } from '@/lib/helpers/is-date-in-past';

import styles from './AiringExpiringRating.module.scss';

dayjs.extend(utc);
interface AiringExpiringProps {
  video: VideoClass;
  className?: string;
}

const AiringExpiringRating = (props: AiringExpiringProps) => {
  const { video, className } = props;

  const { premiere_date, expire_date, content_rating } = video;

  const stringArray = [];

  if (premiere_date) {
    // RWEB-9318 this used to say "Aired" or "Airing" but, since a lot of our content
    // doesn't actually broadcast over the airwaves, that's not really accurate.
    stringArray.push(dayjs.utc(premiere_date).format('M/D/YYYY'));
  }

  if (expire_date) {
    const expirePrefix = isDateInPast(expire_date) ? 'Expired' : 'Expires';
    stringArray.push(`${expirePrefix} ${dayjs.utc(expire_date).format('M/D/YYYY')}`);
  }

  if (content_rating && content_rating !== '') {
    stringArray.push(`Rating ${content_rating}`);
  }

  const joinedStrings = stringArray.join(' | ');

  return (
    <p className={`${styles.aired_expired_rating}${className ? ` ${className}` : ''}`} data-sentry-component="AiringExpiringRating" data-sentry-source-file="AiringExpiringRating.tsx">
      {joinedStrings}
    </p>
  )
}

export default AiringExpiringRating;
